<ng-container *ngIf="categories.includes('Colors')">
  <h2>Color System</h2>

  <div *ngFor="let colorGroup of colorGroups" class="color-group">
    <h3>{{ colorGroup.name }}</h3>
    @if (colorGroup.avoid && colorGroup.usage) {
      <div class="group-wrapper">
        <div class="colors-grid">
          <div
            *ngFor="let color of colorGroup.colors"
            class="color"
            [ngStyle]="{ 'background-color': color.value }"
          ></div>
        </div>
        <div class="color-items">
          <div *ngFor="let color of colorGroup.colors" class="color-details">
            <div
              class="color-small"
              [ngStyle]="{ 'background-color': color.value }"
            ></div>
            <p>
              <strong>{{ color.name }}</strong>
              {{ color.value }}
            </p>
          </div>
        </div>
      </div>
      <div class="group-details">
        <p><strong>Do:</strong> {{ colorGroup.usage }}</p>
        <p><strong>Don't:</strong> {{ colorGroup.avoid }}</p>
      </div>
    } @else {
      <div *ngFor="let color of colorGroup.colors" class="color-item">
        <div
          class="color"
          [ngStyle]="{ 'background-color': color.value }"
        ></div>
        <div class="color-details">
          <p>
            <strong>{{ color.name }}</strong>
            {{ color.value }}
          </p>
          <p><strong>Do:</strong> {{ color.usage }}</p>
          <p><strong>Don't:</strong> {{ color.avoid }}</p>
        </div>
      </div>
    }
  </div>
</ng-container>

<ng-container *ngIf="categories.includes('Spacers')">
  <h2>Spacing System</h2>

  <div *ngFor="let spacer of spacers" class="spacer-item">
    <strong>{{ spacer.name }}</strong>
    <span>{{ spacer.value }}</span>
    <span> ({{ spacer.pixelValue }})</span>
    <div
      class="spacer"
      [ngStyle]="{ width: spacer.value, height: spacer.value }"
    ></div>
  </div>
</ng-container>

<ng-container *ngIf="categories.includes('Layout Scale')">
  <h2>Layout Scale</h2>

  <div *ngFor="let layout of layoutScale" class="spacer-item">
    <strong>{{ layout.name }}</strong>
    <span>{{ layout.value }}</span>
    <span> ({{ layout.pixelValue }})</span>
    <div
      class="scaler"
      [ngStyle]="{ width: layout.value, height: layout.value }"
    ></div>
  </div>
</ng-container>

<ng-container *ngIf="categories.includes('Typography')">
  <h2>Typography System</h2>

  <!-- Mixins -->
  <div class="mixins-wrapper">
    <div *ngFor="let mixin of typography[0].items" class="mixin-item">
      <div class="mixin-details">
        <span [ngClass]="mixin.name">
          <strong class="mixin-name">{{ mixin.name }}</strong> <br /><br />
          <strong>Usage:</strong> {{ mixin.usage }} <br />
          <strong>Desktop:</strong> {{ mixin.desktop.fontSize }} /
          {{ mixin.desktop.lineHeight }} <br />
          <strong>Mobile:</strong> {{ mixin.mobile.fontSize }} /
          {{ mixin.mobile.lineHeight }} <br /><br />
        </span>
      </div>
    </div>
  </div>

  <!-- Variables -->
  <div class="mixins-wrapper">
    <div *ngFor="let subGroup of typography[1].subGroups">
      <h3>{{ subGroup.name }}</h3>
      <div *ngFor="let item of subGroup.items" class="mixin-item">
        @if (subGroup.name === 'Font Sizes') {
          <strong [ngStyle]="{ 'font-size': item.value }">{{
            item.name
          }}</strong>
        } @else {
          <strong
            [ngStyle]="{
              lineHeight: item.value,
              'background-color': '#99dadc',
            }"
            >{{ item.name }}</strong
          >
        }
        <div class="mixin-item">
          <p><strong>Value:</strong> {{ item.value }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
